export enum ImportLineItemsFlow {
  COPY_LINE_ITEMS = 'COPY_LINE_ITEMS',
  MOVE_LINE_ITEMS = 'MOVE_LINE_ITEMS',
}
